import { Button, ContextMenu, Icon, Li, ListItem } from '@startlibs/components';
import { darken } from 'polished';
import { media } from '@startlibs/utils';
import {usePopupToggle, useToggle, willUseSharedState} from '@startlibs/core'
import React, {useEffect} from 'react'
import styled from 'styled-components/macro';
import {CreateBlankStudyDialog} from './CreateBlankStudyDialog'
import {ShareUploadLinkDialog} from './ShareUploadLinkDialog'

export const FileInput = styled.input.attrs({type: 'file'})`
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  ::-webkit-file-upload-button {
    visibility: hidden;
  }
  ::file-upload-button {
    visibility: hidden;
  }
`
const DragAndDropTip = styled(ListItem)`
  pointer-events: auto;
  max-width: 100%;
  background: #f0f6f8;
  margin: 0.5rem 0.5rem 0 !important;
  padding: 1.5rem;
  text-align: center;
  color: #758F9F;
  border-radius: 4px;
  ${Icon} {
    font-size: 36px;
    margin-bottom: 1.5rem;
    position: relative;
  }
  > div {
    padding: 0;
  }
  .dragAndDropTipText {
    max-width: 18rem;
    font-size: 13px;
    margin: auto;
  }
  :hover {
    background: ${props => (darken(0.075, '#f0f6f8'))};
    cursor: pointer;
  }
`

const AddStudiesButtonStyled = styled(Button)`
  ${media.desktop `
    min-width: 15rem;
  `}
`

export const [useShowSampleModal,,setShowSampleModal] = willUseSharedState()

export const AddStudiesButton = ({fileEventHandler,showCreateBlankStudy,showUpload}) => {
  const contextMenu = usePopupToggle()
  const directoryInputRef = usePopupToggle()
  const createBlankStudy = useToggle()
  const shareUploadLinkDialog = useToggle()

  useEffect(() => {
    if (!directoryInputRef.current) return

    directoryInputRef.current.setAttribute('webkitdirectory', 'true')
    directoryInputRef.current.setAttribute('directory', 'true')
    directoryInputRef.current.setAttribute('mozdirectory', 'true')
  },[contextMenu.isOpen])

  return <>
    <AddStudiesButtonStyled onClick={contextMenu.open} highlight withDropdown icon="plus-circle">
    Add studies
    {
      contextMenu.isOpen &&
        <ContextMenu
          onClick={e => e.stopPropagation()}
        >
          {
            showUpload && <Li passTouchThrough keepOpen icon="files" label="Upload from files" prefixWith={<FileInput onChange={(e) => {fileEventHandler(e);contextMenu.close()}} multiple/>}/>
          }
          {
            showUpload && <Li passTouchThrough keepOpen icon="directories" label="Upload from folders or disks" prefixWith={<FileInput ref={directoryInputRef} onChange={(e) => {fileEventHandler(e);contextMenu.close()}}/>}/>
          }
          {
            showCreateBlankStudy && <Li passTouchThrough icon="add-blank" label="Create a blank study" onClick={createBlankStudy.open}/>
          }
          {
            showUpload && <Li icon="link-thin" label="Share Link to Upload Files" onClick={shareUploadLinkDialog.open}/>
          }
          {
            showUpload && <DragAndDropTip noActions css="margin:0;" onMouseEnter={() => setShowSampleModal(true)} onMouseLeave={() => setShowSampleModal(false)} onClick={() => setShowSampleModal(false)}>
              <div>
                <Icon icon="upload"/>
                <div class="dragAndDropTipText">You can also drag and drop study files on this page to upload them</div>
              </div>
            </DragAndDropTip>
          }
        </ContextMenu>
    }
  </AddStudiesButtonStyled>
    {
      createBlankStudy.isOpen &&
      <CreateBlankStudyDialog closeDialog={createBlankStudy.close} />
    }
    {
      shareUploadLinkDialog.isOpen &&
      <ShareUploadLinkDialog closeDialog={shareUploadLinkDialog.close} />
    }
  </>
}